import React, { useState } from "react";
import { Form, Input } from "antd";
import toast from "react-hot-toast";
import { ForgetPasswordApi } from "../../api/request/users"
import { useNavigate } from "react-router-dom";
import LoadableButton from "../../components/buttons/LoadableButton"
import { useSelector } from 'react-redux';
import Message from "../../assets/auth/Message";

function ForgetPassword() {
  const navigate = useNavigate();
  const { broker } = useSelector(state => state.broker);
  const [isLoading, setIsLoading] = useState(false);
  const [FormData, setFormData] = useState({
    email: ""
  })

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { email } = FormData;
    if (!email) {
      toast.error("Email can not be empty");
      return;
    }
    try {
      setIsLoading(true)
      let params = {
        Email: FormData?.email,
        // userType: 0
      }
      const { data } = await ForgetPasswordApi(params);
      if (data?.success) {
        localStorage.setItem('email', FormData?.email);
        navigate("/forgotpassword_otp");
      }
      setIsLoading(false)
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      }
      setIsLoading(false)
    }
  };
  return (
    <div className='flex items-center justify-center min-h-screen bg-[#f9f9f9] auth-bg'>
      <div className='w-full max-w-md bg-white p-10 rounded-2xl shadow-xl'>
        <div className="flex justify-center mb-8">
          <img src='/assets/logo/logo.png' alt='logo' className='h-20 w-48 object-contain' draggable="false" />
        </div>
        <div className="w-full">

          <form autoComplete="off" onSubmit={handleSubmit}>
            <div className="w-full text-sm py-1 ">
              <p className="text-[#585F70] font-semibold ">E-mail</p>
              <div className="relative">
                <Form.Item
                  type="email"
                  name="email"
                >
                  <Input
                    placeholder="Enter your email-id"
                    className="border rounded-lg w-full ps-4 py-2"
                    prefix={
                      <Message />
                    }
                    value={FormData.email}
                    name="email"
                    onChange={handleChange}
                  />
                </Form.Item>
              </div>
            </div>
            <div className="mt-4">
              <LoadableButton type='submit' className='bg-primary text-[#FFFFFF] font-semibold text-lg rounded-lg w-full py-2' lable='Send Code' isLoading={isLoading} loadingLable='Sending Code...' />
            </div>
            <div className="primary flex items-center justify-center mt-5 text-sm">
              <a href="/" className="underline">Back to login</a>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
export default ForgetPassword;
